// extracted by mini-css-extract-plugin
export var container = "speaker-module--container--af0ea";
export var desc = "speaker-module--desc--4ea7e";
export var name = "speaker-module--name--72a49";
export var speaker = "speaker-module--speaker--55e1a";